// #1230 Android Chrome の beforeinstallprompt を捕捉し、任意のタイミングで
// インストールダイアログを出せるようにする。イベントはページロード直後に一度だけ
// 飛ぶため、main.tsx で side-effect import して最速で listener を張る。
type BeforeInstallPromptEvent = Event & {
  prompt: () => Promise<void>
  userChoice: Promise<{ outcome: 'accepted' | 'dismissed' }>
}

let deferred: BeforeInstallPromptEvent | null = null

if (typeof window !== 'undefined') {
  window.addEventListener('beforeinstallprompt', (e) => {
    e.preventDefault()
    deferred = e as BeforeInstallPromptEvent
  })
}

export function canPromptInstall(): boolean {
  return deferred !== null
}

export async function promptInstall(): Promise<boolean> {
  if (!deferred) return false
  const ev = deferred
  deferred = null
  await ev.prompt()
  const choice = await ev.userChoice
  return choice.outcome === 'accepted'
}
